import { render } from "./NewLocation.vue?vue&type=template&id=19263094&scoped=true"
import script from "./NewLocation.vue?vue&type=script&lang=js"
export * from "./NewLocation.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-19263094"

export default script